<template>
  <div class="px-6">
    <a-modal
      title="ยืนยันการส่ง SMS"
      :visible="smsConfirmationVisibility"
      :maskClosable="false"
      @ok="send"
      @cancel="smsConfirmationVisibility = false"
      okText="ส่ง"
      cancelText="ยกเลิก"
    >
      <p class="font-bold mb-2">
        คุณต้องการส่ง SMS ไปยังผู้รับกลุ่มต่างๆหรือไม่
      </p>
    </a-modal>

    <h1 class="text-2xl font-bold mb-4">ส่ง SMS แจ้งเตือน</h1>

    <div>
      <a-form-item
        label="เลือกกลุ่มผู้รับ (เลือกได้มากกว่า 1 กลุ่ม)"
        :validate-status="
          !$v.forms.targets.required && $v.forms.targets.$dirty
            ? 'error'
            : 'success'
        "
        :help="
          !$v.forms.targets.required && $v.forms.targets.$dirty
            ? 'กรุณาเลือกผู้รับอย่างน้อย 1 กลุ่ม'
            : ''
        "
      >
        <a-checkbox-group
          v-model="$v.forms.targets.$model"
          :options="[
            {
              label: `ผู้มีความเสี่ยงสุขภาพสูง ${assessmentGroup.risk_high} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.risk_high_users} คน`,
              value: 'HEALTH_HIGH_RISK',
            },
            {
              label: `ผู้มีความเสี่ยงสุขภาพปานกลาง ${assessmentGroup.risk_medium} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.risk_medium_users} คน`,
              value: 'HEALTH_MEDIUM_RISK',
            },
            {
              label: `ผู้มีความเสี่ยงสุขภาพต่ำ ${assessmentGroup.risk_low} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.risk_low_users} คน`,
              value: 'HEALTH_LOW_RISK',
            },
            {
              label: `ผู้มีคุณภาพชีวิตที่ไม่ดี ${assessmentGroup.quality_of_life_bad} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.quality_of_life_bad_users} คน`,
              value: 'WHOQOL_LOW',
            },
            {
              label: `การมีคุณภาพชีวิตกลางๆ${assessmentGroup.quality_of_life_fair} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.quality_of_life_fair_users} คน`,
              value: 'WHOQOL_MEDIUM',
            },
            {
              label: `การมีคุณภาพชีวิตที่ดี ${assessmentGroup.quality_of_life_good} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.quality_of_life_good_users} คน`,
              value: 'WHOQOL_HIGH',
            },
            {
              label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดีมาก ${assessmentGroup.living_very_good} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.living_very_good_users} คน`,
              value: 'HPLP_VERY_GOOD',
            },
            {
              label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ดี ${assessmentGroup.living_good} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.living_good_users} คน`,
              value: 'HPLP_GOOD',
            },
            {
              label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์พอใช้	${assessmentGroup.living_fair} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.living_fair_users} คน`,
              value: 'HPLP_FAIR',
            },
            {
              label: `ผู้มีวิถีการดำเนินชีวิตอยู่ในเกณฑ์ปรับปรุง ${assessmentGroup.living_bad} คน, ผู้ลงทะเบียน SMS ${assessmentGroup.living_bad_users} คน`,
              value: 'HPLP_BAD',
            },
          ]"
          class="flex flex-col"
        />
      </a-form-item>
    </div>

    <a-form-item
      label="ข้อความ"
      :validate-status="
        !$v.forms.message.required && $v.forms.message.$dirty
          ? 'error'
          : 'success'
      "
      :help="
        !$v.forms.message.required && $v.forms.message.$dirty
          ? 'กรุณาป้อนข้อความ'
          : ''
      "
    >
      <a-textarea
        v-model="$v.forms.message.$model"
        placeholder="ข้อความ..."
        :auto-size="{ minRows: 5, maxRows: 5 }"
      />
    </a-form-item>

    <a-button @click.prevent="smsConfirmationVisibility = true" type="primary" block>ส่งข้อความ</a-button>
  </div>
</template>

<script>
import axios from "axios";
import {
  required,
  minLength,
  maxLength,
  between,
  alpha,
  email,
} from "vuelidate/lib/validators";

export default {
  created() {
    this.fetchGroupNumber();
  },
  data() {
    return {
      forms: {
        targets: [],
        message: "",
      },
      assessmentGroup: null,
      smsConfirmationVisibility: false,
    };
  },
  validations: {
    forms: {
      targets: {
        required,
      },
      message: {
        required,
      },
    },
  },
  methods: {
    async fetchGroupNumber() {
      try {
        const response = await axios({
          method: "GET",
          url: `${process.env.VUE_APP_API_URL}/report/assessment-group`,
        });

        this.assessmentGroup = response.data;
      } catch (error) {
        console.log(error);
      }
    },
    async send() {
      this.$v.$touch();

      if (!this.$v.forms.$invalid) {
        let loader = this.$loading.show({
          container: this.fullPage ? null : this.$refs.formContainer,
        });

        try {
          const { targets, message } = this.forms;

          await axios({
            method: "POST",
            url: `${process.env.VUE_APP_API_URL}/sms`,
            data: {
              targets,
              message,
            },
          });

          this.$notify({
            type: "success",
            group: "foo",
            title: "ส่ง SMS สำเร็จ",
            text: "ผู้รับจะได้รับ SMS เร็วๆนี้",
          });
          loader.hide();
        } catch (error) {
          console.log(error);

          this.$notify({
            type: "error",
            group: "foo",
            title: "ส่ง SMS ไม่สำเร็จ",
            text: "ลองใหม่อีกครั้ง",
          });
          loader.hide();
        }
      }
    },
  },
};
</script>